import React, { Suspense, useState } from 'react';
import { Icon, Drawer, Loader } from '@nearst/ui';
import styles from './InconsistentFieldTag.module.scss';
import StockLevels from '../../InventoryItem/StockLevels';

const InconsistentFieldTag = ({ fieldName, barcode }) => {
	const [drawerOpen, setDrawerOpen] = useState(false);

	const handleClick = () => {
		setDrawerOpen(true);
	};

	const capitalizedFieldName = fieldName ? fieldName.charAt(0).toUpperCase() + fieldName.slice(1) : 'Field';

	return (
		<>
			<div
				className={styles.inconsistentFieldTag}
				onClick={handleClick}
				title="This field has different values across shops in your organisation"
			>
				<Icon className={styles.warningIcon}>warning</Icon>
				<span className={styles.tagText}>Multiple values</span>
			</div>

			<Drawer open={drawerOpen} onOpenChange={setDrawerOpen}>
				<Drawer.Header>
					<Drawer.Title>Values for &lsquo;{capitalizedFieldName}&rsquo;</Drawer.Title>
					<Drawer.Close />
				</Drawer.Header>
				<Suspense fallback={<Loader />}>{barcode && <StockLevels barcode={barcode} fieldName={fieldName} />}</Suspense>
			</Drawer>
		</>
	);
};

export { InconsistentFieldTag };
